import basketsService from '../../services/basketsService'

class BasketsController {
  createBasket = basketsService.createBasket
  updateBasket = basketsService.updateBasket
  fetchBasketShippingMethods = basketsService.fetchBasketShippingMethods
  fetchBasketPaymentOptions = basketsService.fetchBasketPaymentOptions
}

export default new BasketsController()



// WEBPACK FOOTER //
// ../src/controllers/basketsController/basketsController.js